export default "__VITE_ASSET__e166f89e__"